
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  display:block;
  width:100%;
  overflow:hidden;
  background-color:var(--primary-blue-light-2);
}
:host([is-top-right-rounded]) {
  border-top-right-radius:0.75rem;
}
:host([is-top-left-rounded]) {
  border-top-left-radius:0.75rem;
}
:host([is-bottom-right-rounded]) {
  border-bottom-right-radius:0.75rem;
}
:host([is-bottom-left-rounded]) {
  border-bottom-left-radius:0.75rem;
}
.button-cta {
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  padding:2rem;
  color:var(--neutral-white);
  text-decoration-line:none;
}
@media (min-width: 768px) {
  .button-cta {
    flex-direction:row;
  }
}
.button-cta {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
}
.button-cta-heading {
  padding-bottom:0.25rem;
  font-size:var(--fs-2xl);
  line-height:var(--lh-2xl);
  font-weight:var(--fw-bold);
  color:var(--neutral-white);
}
@media (min-width: 768px) {
  .button-cta-heading {
    padding-bottom:0px;
  }
}
.button-cta-heading ::slotted(*) {
  margin-top:0px;
  margin-bottom:0px;
}
.button-cta-text {
  display:flex;
  align-items:center;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  font-weight:var(--fw-semibold);
  color:var(--neutral-white);
}
.button-cta-text ghs-icon {
  margin-left:0.5rem;
}
.button-cta-text ghs-icon {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}
.button-cta-text ghs-icon {
  transition-duration:300ms;
}
.divider {
  margin-left:2rem;
  margin-right:2rem;
  display:none;
  width:1px;
  background-color:var(--primary-blue);
}
@media (min-width: 768px) {
  .divider {
    display:block;
  }
}
.divider{
  height:2.1875rem;
}
.button-cta:hover {
  background-color:var(--primary-blue);
}
.button-cta:hover .divider {
  background-color:var(--primary-blue-light-2);
}
.button-cta:hover ghs-icon{
    transform:translateX(40%);
  }
.button-cta.is-disabled {
  background-color:var(--brand-quaternary);
}
:host([site='BH']) {
  display:flex;
  flex-direction:row;
  align-content:center;
  justify-content:center;
  border-radius:0px;
  background-color:var(--bh-brand-primary-lightest);
  padding-bottom:4rem;
}
:host([site='BH']) .button-cta-heading {
  font-family:var(--bh-ff-body);
}
:host([site='BH']) .button-cta-heading {
  font-size:var(--bh-fs-heading-05);
  line-height:var(--bh-lh-heading-05);
  letter-spacing:var(--bh-ls-heading-05);
}
:host([site='BH']) .button-cta-heading {
  font-weight:var(--fw-light);
}
:host([site='BH']) .button-cta-heading {
  color:var(--neutral-black);
}
:host([site='BH']) .divider {
  margin-left:1.5rem;
  margin-right:1.5rem;
}
:host([site='BH']) .divider {
  align-self:center;
}
:host([site='BH']) .divider {
  background-color:var(--bh-brand-primary-lighter);
}
`;